import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useMemo } from 'react';
import { ArticleCtx } from '..';
import { Link } from '@remix-run/react';
const ArticleMentionedUser = (props) => {
    const { buildHref, onMentionedUserClick } = useContext(ArticleCtx);
    const { id, name } = props;
    const href = useMemo(() => buildHref(`/user/${id}/share`), []);
    const handleClick = useCallback((e) => {
        onMentionedUserClick(e, { id });
    }, []);
    return (_jsx(Link, { className: "l8editor-mention", to: href, onClick: handleClick, children: name }));
};
export const ArticleMentionedUserComponentBuilder = (tag, attr) => {
    if (tag === 'a' && attr['class']?.includes('l8editor-mention')) {
        return {
            constructor: ArticleMentionedUser,
            props: {
                type: attr['data-type'],
                name: attr['data-name'],
                id: attr['data-id'],
            },
        };
    }
    return null;
};
